import { render, staticRenderFns } from "./WomanQuestions.vue?vue&type=template&id=7fa75ec6&scoped=true&"
import script from "./WomanQuestions.vue?vue&type=script&lang=js&"
export * from "./WomanQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa75ec6",
  null
  
)

export default component.exports